import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const ReviewNoteSectionStyled = styled.section`
  text-align: center;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 4rem 2rem;
  margin: 0 0 4rem;
`;

export const InnerContainerStyled = styled.div`
  max-width: 70%;
  margin: 0 auto;

  ${breakpointsMQ4.sm.down} {
    max-width: unset;
  }
`;

export const ReviewNoteTitleStyled = styled.h2`
  ${typography.bold[18]};
  color: ${colors.neutral[900]};
  margin: 0 0 1.6rem;
  letter-spacing: 0.03rem;
`;

export const ReviewNoteSubtitleStyled = styled.p`
  ${typography.regular[16]};
  color: ${colors.neutral[700]};
  margin: 0;
  letter-spacing: 0.02rem;
`;
